module.exports = __webpack_public_path__ + "static/media/ah.2683f752.png";